const HTTP_STATUS = {
  BAD_REQUEST: 400,
  UNSUPPORTED_MEDIA_TYPE: 415,
  INTERNAL_SERVER_ERROR: 500,
  MULTIPLE_CHOICES: 300,
  NOT_FOUND: 404,
  UNAUTHORIZED: 401,
  OK: 200
}

export default HTTP_STATUS
